import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "template-inspo"
};
const _hoisted_2 = {
  class: "template-inspo-wrapper",
  id: "templateInspoWrapper"
};
const _hoisted_3 = {
  class: "temlate-inspo-sidebar"
};
const _hoisted_4 = {
  class: "template-inspo-content"
};
const _hoisted_5 = {
  class: "template-inspo-title"
};
const _hoisted_6 = {
  class: "template-inspo-txt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_card_table = _resolveComponent("card-table");
  const _component_TemplateCard = _resolveComponent("TemplateCard");
  const _component_CreatorFree = _resolveComponent("CreatorFree");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_card_table, {
    "is-mobile": $props.isMobile,
    "target-list": $options.targetList
  }, null, 8, ["is-mobile", "target-list"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("inspo_best_title")), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("inspo_best_info")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.templateList, temp => {
    return _openBlock(), _createBlock(_component_TemplateCard, {
      key: temp.type,
      temp: temp,
      isMobile: $props.isMobile
    }, null, 8, ["temp", "isMobile"]);
  }), 128))])]), _createVNode(_component_CreatorFree, {
    onSignUpFree: $options.signUpFreeFun
  }, null, 8, ["onSignUpFree"])]);
}